import { Link, useParams } from "react-router-dom";
import { Reveal } from "@/components/Reveal";
import { THEMES } from "@/components/ResearchWheel";

export default function AtlasEntry() {
  const { t, s, a } = useParams();
  const ti = Number(t);
  const si = Number(s);
  const ai = Number(a);
  const theme = THEMES[ti];
  const sub = theme?.subs?.[si];
  const article = sub?.articles?.[ai];

  if (!theme || !sub || !article) {
    return (
      <main className="wrap flex min-h-[70vh] flex-col justify-center py-32">
        <p className="overline-mono">404 — Not in the atlas</p>
        <h1 className="mb-8 font-serif text-3xl text-navy sm:text-5xl">This entry has moved.</h1>
        <a href="/#research-atlas" className="btn-ghost w-fit">
          Back to the atlas
        </a>
      </main>
    );
  }

  return (
    <main className="pt-28 lg:pt-36">
      <article className="wrap max-w-3xl pb-24">
        <Reveal>
          <div className="flex flex-wrap items-center gap-3 text-[10px] font-semibold uppercase tracking-[0.2em]">
            <a href="/#research-atlas" className="text-blue transition-colors hover:text-blue-deep">
              Research Atlas
            </a>
            <span className="text-navy-mute">/</span>
            <span className="text-navy">{theme.short}</span>
            <span className="text-navy-mute">/</span>
            <span className="text-navy-mute">{sub.name}</span>
          </div>

          <div className="mt-8 flex items-center gap-4">
            <span className="border border-blue px-2.5 py-1 text-[10px] font-semibold uppercase tracking-[0.2em] text-blue">
              {article.type}
            </span>
            <span className="text-[10px] font-semibold uppercase tracking-[0.2em] text-navy-mute">
              From the Research Atlas
            </span>
          </div>

          <h1 className="mt-6 font-serif text-4xl leading-[1.1] tracking-tight text-navy sm:text-5xl">
            {article.title}
          </h1>
        </Reveal>

        <Reveal delay={0.08}>
          <div className="mt-10 border-l-2 border-blue bg-paper-band p-6 sm:p-8">
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-blue">In brief</p>
            <p className="mt-3 font-serif text-lg italic leading-relaxed text-navy sm:text-xl">{article.brief}</p>
          </div>
        </Reveal>

        <Reveal delay={0.12}>
          <div className="mt-12 border-t border-line pt-8">
            <p className="text-[10px] font-semibold uppercase tracking-[0.25em] text-navy-mute">Sits within</p>
            <p className="mt-4 text-sm leading-relaxed text-navy-soft">
              <span className="font-semibold text-navy">{theme.title}</span> — {theme.blurb}
            </p>
            <p className="mt-3 text-sm leading-relaxed text-navy-soft">
              <span className="font-semibold text-navy">{sub.name}</span> — {sub.detail}
            </p>
          </div>
        </Reveal>

        <Reveal delay={0.16}>
          <div className="mt-12 flex flex-wrap gap-4">
            <Link to={article.type === "Paper" ? "/research" : "/blog"} className="btn-primary">
              {article.type === "Paper" ? "More papers" : "More essays"}
            </Link>
            <a href="/#research-atlas" className="btn-ghost">
              Back to the atlas
            </a>
          </div>
        </Reveal>
      </article>
    </main>
  );
}